import React, {useEffect, useState} from "react";
import Carousel from "./Carousel";
import Tune from "./Tune";
import Cards from "../components/Cards";
import about from '../images/about-us.png';
import why from '../images/why-us.png';
import dummyclient from '../images/dummyclient.png';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/config";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams, useNavigate } from 'react-router-dom';
import Overlay from "../components/Overlay";
import availablebanner from "../images/availberbanner.png";
import new_banner from "../images/new_banner.png";
import play_store from "../images/play_store.png";
import ios_store from "../images/ios_store.png";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Navigation, Pagination } from "swiper/modules";

import RazorpayBadge from "../components/RazorpayBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faCircle
 } from "@fortawesome/free-solid-svg-icons";

 import Helmet from "react-helmet";

const Home = () => {
  const pagination = {
    clickable: true,
  };
  const [sliderdata, setsliderdata] = useState([]);
  const [homepagesliderdata, sethomepagesliderdata] = useState([]);
  const [testimonialdata, settestimonialdata] = useState([]);
  const [blogsdata, setblogsdata] = useState([]);
  const [showloding, setshowloding] = useState(false);

  const [newreleasehindidata, setnewreleasehindidata] = useState([]);
  const [newreleaseenglishdata , setnewreleaseenglishdata ] = useState([]);
  const [newreleasetamildata , setnewreleasetamildata ] = useState([]);
  const [newreleasemalayalamdata , setnewreleasemalayalamdata ] = useState([]);
  const [newreleasebengalidata , setnewreleasebengalidata ] = useState([]);
  const [prebookdata , setprebookdata ] = useState([]);
  const [exclusivedata , setexclusivedata ] = useState([]);
  const [bestsellershindidata , setbestsellershindidata ] = useState([]);
  const [bestsellersenglishdata , setbestsellersenglishdata ] = useState([]);
  const [boxsetsdata , setboxsetsdata ] = useState([]);

  const navigate = useNavigate();

  const fetchdashboarddata = async() => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
          .get(apiUrl + "getdashboarddata?device=web", headers)
          .then((res) => {
            // console.log('getdashboarddata res >>', res.data)
            if(res?.data?.status == 'success') {
              if(res?.data?.sliderdata?.length > 0) {
                setsliderdata(res?.data?.sliderdata);
                // sethomepagesliderdata(res?.data?.homepageproductsdata);
              } else {
                setsliderdata([]);
              }
              // homepage slider data
              // if(res?.data?.homepageproductsdata?.length > 0) {
              //   sethomepagesliderdata(res?.data?.homepageproductsdata);
              // } else {
              //   sethomepagesliderdata([]);
              // }

              //testimonials
              if(res?.data?.testimonialdata?.length > 0) {
                settestimonialdata(res?.data?.testimonialdata);
              } else {
                settestimonialdata([]);
              }

              //blogs
              if(res?.data?.blogsdata?.length > 0) {
                setblogsdata(res?.data?.blogsdata);
              } else {
                setblogsdata([]);
              }

              if(res?.data?.newreleasehindidata?.length > 0) {
                setnewreleasehindidata(res?.data?.newreleasehindidata);
              } else {
                setnewreleasehindidata([]);
              }

              if(res?.data?.newreleaseenglishdata?.length > 0) {
                setnewreleaseenglishdata(res?.data?.newreleaseenglishdata);
              } else {
                setnewreleaseenglishdata([]);
              }

              if(res?.data?.newreleasetamildata?.length > 0) {
                setnewreleasetamildata(res?.data?.newreleasetamildata);
              } else {
                setnewreleasetamildata([]);
              }

              if(res?.data?.newreleasemalayalamdata?.length > 0) {
                setnewreleasemalayalamdata(res?.data?.newreleasemalayalamdata);
              } else {
                setnewreleasemalayalamdata([]);
              }

              if(res?.data?.newreleasebengalidata?.length > 0) {
                setnewreleasebengalidata(res?.data?.newreleasebengalidata);
              } else {
                setnewreleasebengalidata([]);
              }

              if(res?.data?.prebookdata?.length > 0) {
                setprebookdata(res?.data?.prebookdata);
              } else {
                setprebookdata([]);
              }

              if(res?.data?.exclusivedata?.length > 0) {
                setexclusivedata(res?.data?.exclusivedata);
              } else {
                setexclusivedata([]);
              }

              if(res?.data?.bestsellershindidata?.length > 0) {
                setbestsellershindidata(res?.data?.bestsellershindidata);
              } else {
                setbestsellershindidata([]);
              }

              if(res?.data?.bestsellersenglishdata?.length > 0) {
                setbestsellersenglishdata(res?.data?.bestsellersenglishdata);
              } else {
                setbestsellersenglishdata([]);
              }

              if(res?.data?.boxsetsdata?.length > 0) {
                setboxsetsdata(res?.data?.boxsetsdata);
              } else {
                setboxsetsdata([]);
              }


            } else {
              setsliderdata([]);
              sethomepagesliderdata([]);
              settestimonialdata([]);
            }
            
          })
          .catch((err) => {
            alert(err.message);
          });
    setshowloding(false);
    
  }

  const handlenavigation = (data) => {
    console.log('handlenavigation data >>', data)
    // navigate('/productdetails', {state: {data: data}});
    navigate('/entertainment/'+data?.slug)
  }

  const handleopenstorelink = (link) => {
    window.open(link, "_blank");
  }

  useEffect(() => {
    fetchdashboarddata();
  }, [])
  return (
    <>
    <Helmet>
        {/* 🌟 Meta Tags for SEO */}
        <title>Buy Vinyl Records Online in India | Blisstainment</title>
        <meta name="description" content="Shop Hindi, Tamil, English and pre-owned vinyl records, CDs and accessories at Blisstainment. Discover new releases, pre-books and collector LPs across India." />
        <meta name="author" content="Blisstainment" />

       
        {/* ✅ Primary Keyword */}
        <meta name="keywords" content="buy vinyl records online India" />

        {/* ✅ Canonical Tag */}
        <link rel="canonical" href="https://www.blisstainment.com/" />

        {/* ✅ Open Graph (OG) Tags - For Social Media */}
        {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}


        
      </Helmet>
      <Overlay showloader={showloding} />
      <Carousel data={sliderdata} />
      {/* <Tune data={homepagesliderdata} /> */}
      <section className="razorpay-bg">
        <div className="container">
          <div className="razorpaybgdiv">
            <RazorpayBadge />
            <div className="availablebannerbg mobhide">
              <div
                className="playstoreicondiv"
                onClick={() => {
                  handleopenstorelink(
                    "https://play.google.com/store/apps/details?id=com.blisstaimentapp&hl=en_IN"
                  );
                }}
              >
                <img src={play_store} className="play_store_img" />
              </div>
              <div
                className="playstoreicondiv"
                style={{ marginLeft: 0 }}
                onClick={() => {
                  handleopenstorelink(
                    "https://apps.apple.com/in/app/blisstainment/id6751444764"
                  );
                }}
              >
                <img src={ios_store} className="play_store_img" />
              </div>
            </div>
            <img src={availablebanner} className="availablebanner deskhide" />
          </div>
        </div>
      </section>

      {/* Pre Book */}
      {prebookdata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative padtop60">
          <div className="container">
            <h3 className="uppercase text-white">Pre Book</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {prebookdata?.length > 0
                  ? prebookdata?.map((item, index) => {
                      if (item?.Type == "Pre-Book") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* New Release - English */}
      {newreleaseenglishdata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">New Release - English</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {newreleaseenglishdata?.length > 0
                  ? newreleaseenglishdata?.map((item, index) => {
                      // if (item?.Type == "Upcoming") {
                      if (item?.Type == "New Release - English") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* New Release - Hindi */}
      {newreleasehindidata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">New Release - Hindi</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={1}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {newreleasehindidata?.length > 0
                  ? newreleasehindidata?.map((item, index) => {
                      if (item?.Type == "New Release - Hindi") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* New Release - Tamil */}
      {newreleasetamildata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">New Release - Tamil</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {newreleasetamildata?.length > 0
                  ? newreleasetamildata?.map((item, index) => {
                      // if (item?.Type == "Upcoming") {
                      if (item?.Type == "New Release - Tamil") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* New Release - Malayalam */}
      {newreleasemalayalamdata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">New Release - Malayalam</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {newreleasemalayalamdata?.length > 0
                  ? newreleasemalayalamdata?.map((item, index) => {
                      if (item?.Type == "New Release - Malayalam") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* New Release - Bengali */}
      {newreleasebengalidata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">New Release - Bengali</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {newreleasebengalidata?.length > 0
                  ? newreleasebengalidata?.map((item, index) => {
                      if (item?.Type == "New Release - Bengali") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* Exclusive */}
      {exclusivedata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">Exclusive</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {exclusivedata?.length > 0
                  ? exclusivedata?.map((item, index) => {
                      if (item?.Type == "Exclusive") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* Best Sellers - Hindi */}
      {bestsellershindidata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">Best Sellers - Hindi</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={1}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {bestsellershindidata?.length > 0
                  ? bestsellershindidata?.map((item, index) => {
                      if (item?.Type == "Best Sellers - Hindi") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* Best Sellers - English */}
      {bestsellersenglishdata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">Best Sellers - English</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {bestsellersenglishdata?.length > 0
                  ? bestsellersenglishdata?.map((item, index) => {
                      // if (item?.Type == "Upcoming") {
                      if (item?.Type == "Best Sellers - English") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      {/* Box sets */}
      {boxsetsdata?.length > 0 ? (
        <section className="bgclor pd15 text-white relative">
          <div className="container">
            <h3 className="uppercase text-white">Box sets</h3>
            <div className="heading-border left-heading-border"></div>
            <div>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                freeMode={true}
                loop={true}
                navigation={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[FreeMode, Autoplay, Navigation]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 2, // For mobile screens
                  },
                  768: {
                    slidesPerView: 2, // For tablets
                  },
                  1024: {
                    slidesPerView: 4, // For larger screens
                  },
                }}
              >
                {boxsetsdata?.length > 0
                  ? boxsetsdata?.map((item, index) => {
                      if (item?.Type == "Box sets") {
                        var img = null;
                        if (item?.image1) {
                          img = item?.image1;
                        } else if (item?.image2) {
                          img = item?.image2;
                        } else if (item?.image3) {
                          img = item?.image3;
                        } else if (item?.image4) {
                          img = item?.image4;
                        } else if (item?.image5) {
                          img = item?.image5;
                        } else if (item?.image6) {
                          img = item?.image6;
                        } else if (item?.image7) {
                          img = item?.image7;
                        } else if (item?.image8) {
                          img = item?.image8;
                        } else {
                          img = null;
                        }
                        // console.log('img >>', img)
                        return (
                          <SwiperSlide
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handlenavigation(item);
                            }}
                          >
                            <div>
                              <img src={assetsUrl + "products/" + img} />
                            </div>
                          </SwiperSlide>
                        );
                      }
                    })
                  : null}
              </Swiper>
            </div>
          </div>
        </section>
      ) : null}

      <Cards data={blogsdata} />

      <section className="bgclor pd50">
        <div className="container">
          <h3 className="uppercase text-white text-center">About Us</h3>
          <div className="heading-border"></div>

          <div className="row dflex align-items">
            <div className="col-md-12">
              <div className=" text-white">
                <p className="weight600">
                  Indian music has a huge category in the list. Vinyl record is
                  one of the best experiences you can have with music. With the
                  world, the Indian music market went digital with music but
                  quality music having the same essence of the first time it was
                  recorded is what a vinyl record provides. The demand for Vinyl
                  records and CD's is rising with each day. The retro feels and
                  physically owning a record that you can have for decades. The
                  demand-supply equation is lopsided in favour of demand. The
                  real fans and connoisseurs are feeling the pinch. Indian Vinyl
                  is what a true music fan will own in their lifetime. It’s time
                  you own your Vinyl record combined with impeccable sound
                  quality, designed aesthetically only for you.
                </p>
                <p className="weight600">
                  As a true provider for music fans, we understand this hunger
                  at Blisstainment - a brand owned by BASKING SHARK PRIVATE
                  LIMITED.
                </p>
              </div>
            </div>
            {/* <div className="col-md-4">
              <img src={about} className="w100" />
            </div> */}
          </div>
        </div>
      </section>
      <section className=" bgclor pd50 text-white relative">
        <div className="container">
          <h3 className="uppercase text-center text-white">WHY BUY FROM US</h3>
          <div className="heading-border"></div>
          <div className="row dflex align-items">
            {/* <div className="col-md-4">
              <div className="pdr60 text-white">
                <img src={why} className="w100" />
              </div>
            </div> */}
            <div className="col-md-12">
              <p className="weight600">
                Blisstainment was created for the love of music that is imbibed
                in us. A combined experience in the physical music and movie
                distribution industry over four decades, we offer you the ease
                of doing business in India and having the ultimate access to
                music lovers across the breadth and width of the Indian
                subcontinent and the world over. Over the years as the rage for
                Vinyl records have increased immensely we have fulfilled the
                demands of various music lovers looking for their favourite
                music, artist or preferred format.
              </p>
              {/* <p className="weight600">
                Over the years as the rage for Vinyl records have increased
                immensely we have fulfilled the demands of various music lovers
                looking for their favourite music, artist or preferred format.
              </p> */}
            </div>
            <div className="col-md-12 mt-3">
              <ul type="i" className="whyblisstainment-ul">
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>Largest brand new record collection in India.</span>
                </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>All items in Blisstainment are original, authentic and brand
                  new ( We don’t believe in “MINT” words).</span>
                </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>Every item you see in Blisstainment are ready to be shipped.</span>
                  
                </li>
                <li className="weight600">
                <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>There is no standard shipping, everything is express shipping
                  ( Shipped same day).</span>
                  
                </li>
                <li className="weight600">
                <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>More than 15000 orders shipped till date.</span>
                  
                </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>More than 12000 happy consumers.</span>
                  </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>First App to be launched specially for CDs and Records.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="home_btn_div">
           <Link to='contact-us' className="home_btn">Contact</Link>
           
        </div> */}
      </section>
      {/* <section className=" bgclor pd50 text-white relative">
        <div className="container">
          <h3 className="uppercase text-center text-white">
            WHY BLISSTAINMENT
          </h3>
          <div className="heading-border"></div>
          <div className="row dflex align-items">
            <div className="col-md-12">
              <ul type="i" className="whyblisstainment-ul">
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>Largest brand new record collection in India.</span>
                </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>All items in Blisstainment are original, authentic and brand
                  new ( We don’t believe in “MINT” words).</span>
                </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>Every item you see in Blisstainment are ready to be shipped.</span>
                  
                </li>
                <li className="weight600">
                <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>There is no standard shipping, everything is express shipping
                  ( Shipped same day).</span>
                  
                </li>
                <li className="weight600">
                <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>More than 15000 orders shipped till date.</span>
                  
                </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>More than 12000 happy consumers.</span>
                  </li>
                <li className="weight600">
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="sidebarnavicons"
                    style={{ color: "white" }}
                  />
                  <span>First App to be launched specially for CDs and Records.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className=" bgclor pd50 text-black relative">
        <div className="container">
          <h3 className="uppercase text-center text-white">
            CLIENT TESTIMONIALS
          </h3>
          <div className="heading-border"></div>

          <div className="row dflex align-items">
            <Swiper
              slidesPerView={2}
              spaceBetween={20}
              // freeMode={true}
              loop={true}
              navigation={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, Navigation]}
              className="mySwiper1"
            >
              {testimonialdata?.length > 0
                ? testimonialdata?.map((item, index) => {
                  console.log('testimonialdata item >>', item);
                    var image = null;
                    if (item?.image) {
                      image = item?.image;
                    } else {
                      image = "pp.png";
                    }
                    return (
                      <SwiperSlide className="testislider" key={index}>
                        <div className="col-md-12">
                          <div className="clientdiv">
                            <div className="dflex align-items">
                              <div className="clientPic text-center">
                                <img
                                  src={assetsUrl + "sliders/" + image}
                                  className="testimonialimage"
                                />
                                <p className="clrred fs22 mt-3">{item?.name}</p>
                                <p className="clrgrey fs18">
                                  {item?.location ? item?.location : item?.location1 ? item?.location1 : ""}
                                </p>
                              </div>

                              <div className="clientText ml30">
                                <p className="fs16">{item?.content}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })
                : null}
            </Swiper>
          </div>
        </div>
      </section> */}
      <section className=" bgclor pd50 text-black relative">
        <div className="container">
          <h3 className="uppercase text-center text-white">
            CLIENT TESTIMONIAL
          </h3>
          <div className="heading-border"></div>

          <div className="row dflex align-items">
            <Swiper
              slidesPerView={2}
              spaceBetween={20}
              // freeMode={true}
              loop={true}
              navigation={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, Navigation]}
              className="mySwiper1"
              breakpoints={{
                0: {
                  slidesPerView: 1, // For mobile screens
                },
                768: {
                  slidesPerView: 1, // For tablets
                },
                1024: {
                  slidesPerView: 2, // For larger screens
                },
              }}
            >
              {testimonialdata?.length > 0
                ? testimonialdata?.map((item, index) => {
                    var image = null;
                    if (item?.image) {
                      image = item?.image;
                    } else {
                      image = "pp.png";
                    }
                    return (
                      <SwiperSlide className="testislider" key={index}>
                        <div className="col-md-12">
                          <div className="clientdiv">
                            <div className=" align-items">
                              {/* <div className="clientPic text-center">
                                <img
                                  src={assetsUrl + "sliders/" + image}
                                  className="testimonialimage"
                                />
                                <p className="clrred fs22 mt-3">{item?.name}</p>
                                <p className="clrgrey fs18">
                                  {item?.designation}
                                </p>
                              </div> */}

                              <div className="clientText ml30">
                                <p className="fs16">{item?.content}</p>
                                <p className="clrred fs22 mt-3">{item?.name}</p>
                                <p className="clrgrey fs18">{item?.location}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })
                : null}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
